<template>
    <div class="landing-page">
        <h1 class="text-center mt-5">What would you like to do today?</h1>
        <div class="row mb-2 mt-5 justify-content-center" v-if="client.plan_level === 'insights' || client.plan_level === 'trial'">
            <div class="col-12 col-sm-10 col-md-12 col-lg-10 col-xl-10">
                <div class="card mx-2 mb-4 two-space-tile">
                    <div class="card-body text-center tile-body">
                        <a :href="'/insights/'+client.url">
                            <i class="fas fa-chart-pie fa-5x"></i>
                            <h3 class="mt-3 mb-0">Insights</h3>
                            <p class="tile-description">Explore the latest insights from your fundraising and marketing program</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-2 justify-content-center">
            <div class="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-5">
                <div class="card mx-2 mb-4 tile">
                    <div class="card-body text-center tile-body">
                        <a :href="'/settings/'+client.url+'/integrations'">
                            <i class="fas fa-plug fa-5x"></i>
                            <h3 class="mt-3 mb-0">Setup Integrations</h3>
                            <p class="tile-description">Create or update connections into your 3rd party systems</p>
                        </a>
                    </div>
                </div>
            </div>
            
            <div class="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-5" v-if="client.census_api_key && (client.plan_level === 'insights' || client.plan_level === 'trial')">
                <div class="card mx-2 mb-4 tile">
                    <div class="card-body text-center tile-body">
                        <a :href="'/pathways/'+client.url+'/push_audience/'">
                            <i class="fas fa-arrow-right-arrow-left fa-5x"></i>
                            <h3 class="mt-3 mb-0">Create Pathways</h3>
                            <p class="tile-description">Link your marketing and fundraising tools together to keep your data in sync</p>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-5" v-else>
                <div class="card mx-2 mb-4 tile">
                    <div class="card-body text-center tile-body">
                        <a :href="'/year_end_benchmarks/'+client.url">
                            <i class="fas fa-chart-pie fa-5x"></i>
                            <h3 class="mt-3 mb-0">Benchmarks</h3>
                            <p class="tile-description">Explore the latest trends across the non-profit industry</p>
                        </a>
                    </div>
                </div>
            </div>
            
            <div class="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-5" v-if="user.agency_id !== null && user.organization === 'NextAfter'">
                <div class="card mx-2 mb-4 tile">
                    <div class="card-body text-center tile-body">
                        <a v-if="published_plan" :href="'/results/'+client.url+'/projections'">
                            <i class="fas fa-chart-simple fa-5x"></i>
                            <h3 class="mt-3 mb-0">View Projections vs. Actuals</h3>
                            <p class="tile-description">Track the performance of your initiatives compared to initial projections</p>
                        </a>
                        <a v-else-if="active_plan" :href="'/planning/'+active_plan.url+'/annual'">
                            <i class="fas fa-chart-simple fa-5x"></i>
                            <h3 class="mt-3 mb-0">Update an Annual Plan</h3>
                            <p class="tile-description">Build program projections tied to individual initiative performance</p>
                        </a>
                        <a v-else :href="'/planning/'+client.url+'/versions'">
                            <i class="fas fa-chart-simple fa-5x"></i>
                            <h3 class="mt-3 mb-0">Create an Annual Plan</h3>
                            <p class="tile-description">Create a new plan for your upcoming fiscal year</p>
                        </a>
                    </div>
                </div>                
            </div>

            <div v-if="playbook_count !== 0 && user.agency_id !== null" class="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-5">
                <div class="card mx-2 mb-4 tile">
                    <div class="card-body text-center tile-body">
                        <a :href="'/playbooks/'+client.url">
                            <i class="fas fa-envelopes-bulk fa-5x"></i>
                            <h3 class="mt-3 mb-0">View All Playbooks</h3>
                            <p class="tile-description">Create a new playbook, import an existing playbook to create additional assets, or add assets to an existing playbook</p>
                        </a>
                    </div>
                </div>                
            </div>
            <div v-if="playbook_count === 0 && user.agency_id !== null" class="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-5">
                <div class="card mx-2 mb-4 tile">
                    <div class="card-body text-center tile-body">
                        <a :href="'/playbooks/'+client.url+'/new'">
                            <i class="fas fa-envelopes-bulk fa-5x"></i>
                            <h3 class="mt-3 mb-0">Create a Playbook</h3>
                            <p class="tile-description">Build a new playbook based upon your strategic goals</p>
                        </a>
                    </div>
                </div>
            </div>            
        </div>

        <!-----------------------------------------end of tiles  ------------------------------------------>
        <div class="row mb-3 justify-content-center" v-if="notif.length">
            <div class="col-12 col-sm-10 col-md-12 col-lg-10 col-xl-10">
                <h2>Notifications ({{ notif.length }})</h2>
                <div class="card mx-2">
                    <div class="card-body">
                        <div v-for="(n, index) in notif" :key="n.id">
                            <span class="float-end lh-1">{{ date(n.created_at) }}</span>
                            <h4 class="mb-2">{{ n.data['client_name'] }}</h4>
                            <p>{{ n.data['error_msg'] }}</p>
                            <p class='mb-0'>
                                <button v-if="n.data['cta'] !== null" class="btn btn-sm btn-primary me-2" @click="markRead(n)">{{ n.data['cta'] }}</button> 
                                <button class="btn btn-secondary btn-sm" @click="dismiss(n)">Dismiss</button>
                            </p>
                            <hr v-if="index !== notif.length - 1"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        user: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: true
        },
        playbooks: {
            type: Array,
            required: true
        },
        published_plan: {
            type: Object,
            default: null
        },
        active_plan: {
            type: Object,
            default: null
        },
        notifications: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            notif: [],
            playbook_count: 0,
            experiment_treatment_count: 0,
            tile_count: 0
        };
    },
    beforeMount() {
        this.playbooks.forEach((c) => {
            if(c.playbook_type_id === 0) {
                this.experiment_treatment_count++;
            } else {  
                this.playbook_count++;
            }
        });
    },
    mounted() {
        // Ensure notifications is an array before filtering
        this.notif = (Array.isArray(this.notifications) ? this.notifications : []).filter((n) => {
            return n.data['client_id'] === this.client.id || n.data['client_name'] === this.client.name;
        });
        this.tile_count = 1; // one tile always display: integration
        if(this.client.census_api_key) {
            // show pathway tile
            this.tile_count++;
        }
        if(this.user.agency_id !== null) {
            // show planning tile
            this.tile_count++;
        
            if(this.playbook_count === 0) {
                // show add playbook tile
                this.tile_count++;
            }
            if(this.playbook_count !== 0) {
                // show view playbooks tile
                this.tile_count++;
            }
            if(this.experiment_treatment_count === 0) {
                // show add experiment treatment tile
                this.tile_count++;
            }
            if(this.experiment_treatment_count !== 0) {
                // show view experiment treatment tile
                this.tile_count++;
            }
        }
    },
    methods: {
        markRead(n) {
            this.dismiss(n);
            document.location = n.data['url'];
        },
        dismiss(n) {
            window.axios.get('/api/notification/read/' + n.id);

            //Remove the notification from the list
            for(var i = 0; i < this.notif.length; i++) {
                if(this.notif[i].id === n.id) {
                    this.notif.splice(i, 1);
                }
            }
        },
    }
});
</script>
